// DateTimeSelector.tsx
import { Dayjs } from "dayjs";
import { DateTime, DateTimeRange } from "views/components/DatePicker";
import styles from "./style.module.scss";
import classNames from "classnames";

interface DateTimeSelectorProps {
  mode: "Single" | "Range";
  value: { single: Dayjs | null; range: [Dayjs, Dayjs] | null };
  onChange: (newValue: {
    single: Dayjs | null;
    range: [Dayjs, Dayjs] | null;
  }) => void;
}

export default function DateTimeSelector({
  mode,
  value,
  onChange,
}: DateTimeSelectorProps) {
  const dateTimeComponent = {
    Single: (
      <DateTime
        value={value.single}
        onChange={(v) => onChange({ ...value, single: v })}
      />
    ),
    Range: (
      <DateTimeRange
        value={value.range}
        onChange={(v) => onChange({ ...value, range: v })}
      />
    ),
  };

  return (
    <div className={classNames(styles.dateTimeContainer)}>
      {dateTimeComponent[mode]}
    </div>
  );
}
